import { useCallback } from "react";
import { rutaDeCliente } from "@/routes/routeConfig";
import { useSlugDeLaUrl } from "./useSlugDeLaUrl";

/**
 * Enlaces internos del cliente en pantalla: `ruta("propuestas/historial")` → `/c/{slug}/propuestas/historial`.
 * Un enlace absoluto sin cliente (`/propuestas`) caería en una redirección antigua que adivina el cliente.
 */
export function useRutaCliente(): (ruta: string) => string {
  const slug = useSlugDeLaUrl();
  return useCallback((ruta: string) => (slug ? rutaDeCliente(slug, ruta) : "/"), [slug]);
}
